<style lang="less" scoped>
.bt_list_d{
    .item{
        .it{
            justify-content:space-around !important;
        }
    }
}
  .bt_list{
    width:100%;
    padding: 0rem 5%;
    box-sizing: border-box;
    .item{
        width: 100%;
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        padding: 1rem 0px;
        height: 5rem;
        .img{
            width: 40%;
            height: 100%;
            border-radius: 10px;
        }
        .it{
            padding-left: 10px;
            box-sizing: border-box;
            flex: 1;
            display: flex;
            flex-flow: column wrap;
            justify-content: space-between;
            align-items:flex-start;    
            height: 100%;
            width: 60%;
            div{
                width:100%;
            }
            .d1{
                // height:2.1rem;
                height:33px;
                line-height: 1.1rem;
                color:#000;
                overflow : hidden;/*必须结合的属性,当内容溢出元素框时发生的事情*/
                text-overflow: ellipsis;/*可以用来多行文本的情况下，用省略号“…”隐藏超出范围的文本 。*/
                display: -webkit-box;/*必须结合的属性 ，将对象作为弹性伸缩盒子模型显示 。*/
                -webkit-line-clamp: 2;/*用来限制在一个块元素显示的文本的行数。*/
                -webkit-box-orient: vertical;/*必须结合的属性 ，设置或检索伸缩盒对象的子元素的排列方式 。*/
            }
            .d2{
                color: rgb(6,160,156);
                font-size: 12px;
                overflow: hidden;
                text-overflow:ellipsis;
                white-space: nowrap;
                span+span{
                    margin-left: 5px;
                }
            }
            .d3{
                font-size: 14px;
                // color:#969799;
                color: rgb(243,28,109);
                span+span{
                    margin-left: 1rem;
                }
            }
            .dd1{
                color: #969799;
                font-size: 14px;
                height: 31px;
            }
            .dd3{
                font-size: 16px;
                color:#000 !important;
                span:first-child{
                    width: 30% !important;
                }
                span{
                    width: calc(50% - 1.4rem);
                    display: inline-block;
                    white-space:nowrap;//不换行
                    overflow: hidden;//超出隐藏
                    text-overflow: ellipsis;//变成...
                }
                span:last-child{
                    width:auto !important;
                }
            }
        }
    }
    .item+.item{
        border-top: 1px solid #f1f1f1;
    }
  }
</style>
<template>
<div>
    <div class="bt_list" v-if="!isDet&&!isDels">
      <div @click="jumpDet(item)" v-if="item" class="item" v-for="(item,i) in listData" :key="i">
        <img class="img" :src="item.thumb_img">
        <div class="it">
          <div class="d1">{{item.title}}</div>
          <div class="d2">
              <span v-if="item" v-for="(it,a) in item.tags.split(',')" :key="a">
                <span v-if="it && it.indexOf('，')!=-1" v-for="(data,b) in it.split('，')" :key="b">
                    <span>#</span>
                    {{data}}
                </span>
                <span v-if="it && it.indexOf('，')==-1">
                    <span>#</span>
                    {{it}}
                </span>
              </span>
          </div>
          <div class="d3">
                <span>
                    <img width="15px" src="../assets/image/homePage/dz.png">
                    {{item.zan_num}}
                </span>
                <span>
                    <img width="20px" src="../assets/image/homePage/gk.png">
                    {{item.page_views}}
                </span>
          </div>
        </div> 
      </div>
    </div>
    <div class="bt_list bt_list_d" v-if="isDet">
      <div v-if="item" class="item" v-for="(item,i) in listData" :key="i" @click="open(item)">
      <!-- <router-link tag="div" :to="{path: '/detiles/' + item.id}" v-if="item" class="item" v-for="(item,i) in listData" :key="i"> -->
        <img class="img" :src="item.img">
        <div class="it">
          <!-- <div class="d2">
              <span v-if="item.tags!=''" v-for="(it,a) in (item.tags||'').split(',')" :key="a">{{it}}</span>
          </div> -->
          <div class="d3 dd3">
                <span>
                    {{item.name}}
                </span>
                <span>
                    {{item.position}}
                </span>
                <span style="float:right;color:#20a5a2;margin-left:0px;">
                    详情>
                </span>
          </div>
          <div class="d1 dd1">
              {{item.college}}
          </div>
        </div> 
      <!-- </router-link> -->
      </div>
    </div>
    <div class="bt_list" v-if="!isDet&&isDels">
        <div v-if="item" class="item" v-for="(item,i) in listData" :key="i" @click="handleisDels(item)">
        <img class="img" :src="item.thumb_img">
        <div class="it">
          <div class="d1">{{item.title}}</div>
          <div class="d2">
              <!-- <span v-if="item" v-for="(it,a) in item.tags.split(',')" :key="a">
                <span v-if="it && it.indexOf('，')!=-1" v-for="(data,b) in it.split('，')" :key="b">
                    <span>#</span>
                    {{data}}
                </span>
                <span v-if="it && it.indexOf('，')==-1">
                    <span>#</span>
                    {{it}}
                </span>
              </span> -->
          </div>
          <div class="d3">
                <span>
                    <img width="15px" src="../assets/image/homePage/dz.png">
                    {{item.zan_num}}
                </span>
                <span>
                    <img width="20px" src="../assets/image/homePage/gk.png">
                    {{item.page_views}}
                </span>
          </div>
        </div> 
      </div>
    </div>
    <van-popup v-model="showPopup" :style="{ width: '80%' , borderRadius: '10%'}">
      <img src="../assets/image/homePage/jsz.png" width="100%">
    </van-popup>
</div>
</template>
<script>
export default {
    props:["listData","isDet","isDels"],
    data(){
        return{
            showPopup:false
        }
    },
    methods:{
        jumpDet(item){
            sessionStorage.setItem("activeItem",0);
            this.$router.push({
                path: '/detiles/' + item.id,
                query:{
                    urls:JSON.stringify(this.$route.path)
                }
            })
        },
        open(item){
            this.$router.push({
                path:"/detilesZJ",
                query:{
                    l_id:item.id 
                } 
            })
            // this.showPopup =true;
        },
        handleisDels(item){
            this.$router.push({
                path:"/detilseNew",
                query:{
                    article_id:item.id 
                } 
            })
        }
    },
    mounted(){
        // console.log(this.$route)
        // console.log(this.isDet)
    }
}
</script>